<template>
  <div class="w-full">
    <b-row>
      <b-modal id="modal-assign" hide-footer ref="assignSubmissions" title="Assign Submission">
        <Assignment :id="assignTrackingNumber" type="business-annual-returns" permission="can_view_business_annual_returns_tasks"/>
      </b-modal>
    </b-row>

    <b-row>
      <b-col cols="3">
        <b-form-input
          class="text-gray text-sm noFocus mx-2 my-2"
          style="padding:6px 5px;"
          v-model="trackingNumber"
          type="text"
          placeholder="Search Tracking Number"
          required
          v-on:keyup.enter="fetch">
        </b-form-input>
      </b-col>
      <b-col cols="2">
        <b-form-group>
          <b-form-select
            v-model="statuses"
            v-on:change="fetch"
            class="form-select noFocus text-gray mx-2 my-2 text-sm">
            <b-select-option :value="null">--Filter by Status--</b-select-option>
            <b-select-option value="DRAFT">Draft</b-select-option>
            <b-select-option value="SUBMITTED">In Queue</b-select-option>
            <b-select-option value="ASSIGNED">Assigned</b-select-option>
            <b-select-option value="QUERIED">Queried</b-select-option>
            <b-select-option value="APPROVED">Approved</b-select-option>
            <b-select-option value="ESCALATED">Escalated</b-select-option>
              <b-select-option value="AWAITING_PAYMENT">Confirming payment</b-select-option>
              <b-select-option value="PAYMENT_FAILED">Payment failed</b-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
      </b-col>
    </b-row>
    <div class="mx-auto">
      <b-progress value="100" v-if="loading"  variant="#007ac5" height="0.2rem" animated></b-progress>
    </div>
    <b-row>
      <b-col cols="12">
        <table class="min-w-full leading-normal">
          <thead>
          <tr class="border-b border-t border-grey">
            <th class="t-header">Tracking No.</th>
            <th class="t-header">BRN</th>
            <th class="t-header">Name</th>
            <th class="t-header text-center">Status</th>
            <th class="t-header text-center">Registrar Name</th>
            <th class="t-header text-center">Date</th>
            <th class="t-header text-center">Action</th>
          </tr>
          </thead>

          <tbody>
          <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(submission, idx) in submissions" :key="idx">
            <td class="t-body text-blue font-bold cursor-pointer hover:underline" @click="showDetails(submission.trackingNumber)">{{submission.trackingNumber	}}</td>
            <td class="t-body font-bold">{{submission.brn}}</td>
            <td class="t-body font-bold">{{submission.name}}</td>
            <td class="t-body">
              <p class="text-xs px-2 py-1 text-capitalize text-center" style="background: #f1f1f1">
                <span :class="(submission.status === 'PENDING') ? 'text-gray'
                : (submission.status.toUpperCase() === 'AWAITING_PAYMENT_CONFIRMATION')? 'text-gray'
                : (submission.status.toUpperCase() === 'PAYMENT_FAILED')? 'text-red'
                : (submission.status === 'ASSIGNED') ? 'text-blue'
                : (submission.status === 'APPROVED') ? 'text-green'
                : (submission.status === 'QUERIED') ? 'text-orange' : ''">
                    <span v-if="submission.status.toUpperCase() === 'AWAITING_PAYMENT_CONFIRMATION'">
                      Confirming Payment
                    </span>
                    <span v-else-if="submission.status.toUpperCase() === 'PENDING'">
                      In Queue
                    </span>
                    <span v-else>
                      {{ submission.status.toLowerCase().replaceAll("_", " ") }}
                    </span>
                </span>
              </p>
            </td>

            <td class="t-body text-center">
              <span v-if="submission.registrarName" class="text-uppercase">{{ submission.registrarName }}</span>
              <span v-else>-</span>
            </td>
            <td class="t-body text-center">
              {{dateTimeFormat(submission.createdAt || submission.submissionDate)}}
            </td>
            <td class="t-body text-center">
              <b-row v-if="submission.status.toUpperCase() === 'AWAITING_PAYMENT_CONFIRMATION'">
                <b-col>
                  <button
                    class="text-xs bg-blue text-white px-2 py-1 rounded-sm" @click="move(submission, idx)">
                    Move to Queue <b-spinner v-if="loadingMoveTask && selectedIdx === idx" small></b-spinner>
                  </button>
                </b-col>
                <b-col>
                  <button
                    class="text-xs bg-red text-white px-2 py-1 rounded-sm" @click="removePayment(submission.trackingNumber, idx)">
                    Remove Payment <b-spinner v-if="loadingRemovePayment && selectedIdx === idx" small></b-spinner>
                  </button>
                </b-col>
              </b-row>
              <button
                v-else-if="submission.status.toUpperCase() === 'ESCALATED' && canViewActionWithPermission('can_assign_annual_return_application')"
                class="text-xs bg-blue text-white px-2 py-1 rounded-sm" @click="assignPrompt(submission, 'Escalation')">
                <i class="fa fa-reply mx-1"></i>Assign
              </button>
              <button
                v-else-if="submission.status.toUpperCase() === 'ASSIGNED' && canViewActionWithPermission('can_assign_annual_return_application')"
                class="text-xs bg-red text-white px-2 py-1 rounded-sm" @click="assignPrompt(submission)">
                <i class="fa fa-reply mx-1"></i>Assign
              </button>
              <button
                v-else-if="submission.status.toUpperCase() === 'PENDING' && canViewActionWithPermission('can_assign_annual_return_application')"
                class="text-xs bg-green text-white px-2 py-1 rounded-sm" @click="assignPrompt(submission)">
                <i class="fa fa-plus mx-1"></i>Assign
              </button>
              <p v-else class="text-xs">No action</p>
            </td>
          </tr>
          <tr>
            <td v-if="submissions.length === 0" colspan="7" class="bg-inertgrey text-center py-1">
              <span class="text-sm">No results found</span>
            </td>
          </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row class="mx-1" v-if="pagination.totalPages > 1">
      <b-col cols="1">
        <button @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
      </b-col>
      <b-col cols="1">
        <b-row>
          <b-col cols="12">
            <p class="paginate-details text-center">
              <b-badge class="bg-blue text-white">
                {{currentPage}}/{{pagination.totalPages}}
              </b-badge>
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="1" >
        <button @click="next" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">Next</button>
      </b-col>
      <b-col cols="8"></b-col>
      <b-col cols="1">
        <b-row>
          <b-col>
            <p class="paginate-details text-center text-xs font-bold">{{currentPage * limit}} of {{pagination.totalElements}}</p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Assignment from "@/views/home/commons/Assignment";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AllBusinessAnnualReturnsSubmissions",
  components: { Assignment },
  data(){
    return{
      count:0,
      loading:false,
      currentPage:1,
      limit:12,
      submissions:[],
      pagination:{
        totalElements: 0,
        totalPages:0
      },
      documents:[],
      statuses: null,
      assignTrackingNumber:null,
      selectedIdx:null,
      loadingMoveTask:false,
      loadingRemovePayment:false,
      loadingResend:false,
      rows:{
        odd:"border-t border-grey hover:bg-header_grey",
        even:"border-t border-grey bg-header_grey"
      },
      trackingNumber: "",
      brn:null,
    }
  },
  mounted() {
      this.statuses = ""
    this.fetch()
  },
  methods:{
    ...mapActions(["redoTransaction", "fetchBusinessAnnualReturnsSubmissions", "removeAnnualReturnsPayment"]),
    fetch(){
      let options = this.statuses
      if(this.statuses === null){
        options = ""//DRAFT,PENDING,ASSIGNED,APPROVED,QUERIED,ESCALATED,AWAITING_PAYMENT_CONFIRMATION"
      }
      let data = {
        search: this.trackingNumber,
        status:options,
        page:this.currentPage,
        limit:this.limit,
      }
      this.loading = true
      console.log(data)
      this.fetchBusinessAnnualReturnsSubmissions(data)

    },
    next(){
      if(this.currentPage < this.pagination.totalPages){
        this.currentPage++
        this.fetch()
      }
    },
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
        this.fetch()
      }else{
        this.warningToast("Observation", "No more data to show")
      }
    },
    assignPrompt(data){
      this.loading = true
      this.assignTrackingNumber = data.trackingNumber
      this.$refs.assignSubmissions.show();
    },
    move(application, idx){
      this.selectedIdx = idx
      let data = {
        userId: JSON.parse(sessionStorage.getItem("current_user")).userId,
        prn: application.prn
      }
      this.loadingMoveTask = true
      this.redoTransaction(data)
    },
    removePayment(trackingNumber, idx){
      this.selectedIdx = idx
      let data = {
        trackingNo:trackingNumber
      }
      this.loadingRemovePayment = true
      this.removeAnnualReturnsPayment(data)
    },
    showDetails(trackingNumber){
      this.$emit("openDetails", trackingNumber)
    },
      canViewActionWithPermission(permission) {
          return this.$can(permission, "general") === true;
      }
  },
  computed:{
    ...mapGetters(["getBusinessAnnualReturnsSubmissions", "getMoveTask", "getMoveTaskError", "getBusinessAnnualReturnPaymentRemoved"])
  },
  watch:{
      getBusinessAnnualReturnsSubmissions(data){
      this.loading = false
      this.submissions = data.content || []
      this.pagination = {
        totalPages: data.totalPages,
        totalElements: data.totalCount ?? data.totalElements ?? 0,
      }
    },
    getMoveTask(){
      this.loadingMoveTask = false
      this.successToast("Success", "task move initiated")
    },
    getMoveTaskError(data){
      this.loadingMoveTask = false
      this.errorToast("Error", data.message)
    },
    getBusinessAnnualReturnPaymentRemoved(){
      this.fetch()
      this.loadingMoveTask = false
      this.successToast("Success", "payment details removed")
    }
  }
};
</script>

<style scoped>
.assign-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-green text-green text-xs w-full;
}

.assign-btn:hover{
  @apply bg-green text-white;
}

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>